import CryptoJS from 'crypto-js'
import config from "../api/config"
// 定义密钥和偏移量（需要前后端一致）
const KEY = CryptoJS.enc.Utf8.parse(config.K)
const IV = CryptoJS.enc.Utf8.parse(config.N)

/**
 * AES 加密
 * @param {string} plainText 明文
 * @returns {string} 加密后的密文
 */
export function encrypt(plainText) {
    if (!plainText) return ''

    const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(plainText),
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    )

    return encrypted.toString()
}

/**
 * AES 解密
 * @param {string} cipherText 密文
 * @returns {string} 解密后的明文
 */
export function decrypt(cipherText) {
    if (!cipherText) return ''

    const decrypted = CryptoJS.AES.decrypt(
        cipherText,
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    )

    return decrypted.toString(CryptoJS.enc.Utf8)
}